<template>
  <div class="vehicle-options-browse container-fluid">
    <link href="https://fonts.googleapis.com/css?family=Racing+Sans+One" rel="stylesheet">
    <div class="car-options options-row row" v-if="images.sedans.length > 0" :style="{backgroundImage: sedanBox}">
      <div class="col-sm-6 hidden-xs">
        <h1 class="header-lg text-center">{{brandName}} Cars</h1>
      </div>
      <div class="col-sm-6 clip-right white-background">
        <h1 class="header-sm visible-xs text-center">{{brandName}} Cars</h1>
        <div class="row flex-row">
          <div class="col col-xs-6" :style="{width: carCol}" v-for="sedan in images.sedans" :key="sedan.modelName">
            <div class="car-wrapper">
              <a href="#">
                <img class="center-block img-responsive" :alt="sedan.modelName" :src="sedan.angleView">
              </a>
              <span class="text-center">{{sedan.modelName}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="suv-options options-row row" v-if="images.suvs.length > 0" :style="{backgroundImage: suvBox}">
      <div class="col-sm-6 clip-left white-background">
        <h1 class="header-sm visible-xs text-center">{{brandName}} SUVs</h1>
        <div class="row flex-row">
          <div class="col col-xs-6" :style="{width: suvCol}" v-for="suv in images.suvs" :key="suv.modelName">
            <div class="suv-wrapper">
              <a href="#">
                <img class="img-responsive center-block" :alt="suv.modelName" :src="suv.angleView">
              </a>
              <span class="text-center">{{suv.modelName}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 hidden-xs">
        <h1 class="header-lg text-center">{{brandName}} SUVs</h1>
      </div>
    </div>
    <div class="truck-options options-row row" v-if="images.trucks.length > 0" :style="{backgroundImage: truckBox}">
      <div class="col-sm-6 hidden-xs">
        <h1 class="header-lg text-center">{{brandName}} Trucks</h1>
      </div>
      <div class="col-sm-6 clip-right white-background">
        <h1 class="header-sm text-center visible-xs">Toyota Trucks</h1>
        <div class="row flex-row">
          <div class="col col-xs-6" :style="{width: truckCol}" v-for="truck in images.trucks" :key="truck.modelName">
            <div class="truck-wrapper">
              <a href="#">
                <img class="img-responsive center-block" :alt="truck.modelName" :src="truck.angleView">
              </a>
              <span class="text-center">{{truck.modelName}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      sedanBox: 'url(' + this.images.lifestyleImages.sedanImage + ')',
      suvBox: 'url(' + this.images.lifestyleImages.suvImage + ')',
      truckBox: 'url(' + this.images.lifestyleImages.truckImage + ')'
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    carCol () {
      if (this.images.sedans.length % 3 === 0) {
        return '33.3%';
      } else if (this.images.sedans.length > 4) {
        return '33.3%';
      } else {
        return '50%';
      }
    },
    suvCol () {
      if (this.images.suvs.length % 3 === 0) {
        return '33.3%';
      } else if (this.images.suvs.length > 4) {
        return '33.3%';
      } else {
        return '50%';
      }
    },
    truckCol () {
      if (this.images.trucks.length % 3 === 0) {
        return '33.3%';
      } else {
        return '50%';
      }
    }
  },
  mounted() {
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.vehicle-options-browse {
  font-size: 16px;
  background: #fff;
}
.vehicle-options-browse .car-options {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/020/384/original/toyota-camry-compressor.jpg?1539801193);
  background-size: cover;
  background-position: center;
}
.vehicle-options-browse .suv-options {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/020/385/original/toyota-highlander-compressor.jpg?1539801223);
  background-size: cover;
  background-position: center;
}
.vehicle-options-browse .truck-options {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/020/391/original/toyota-tacoma-compressor.jpg?1539806498);
  background-size: cover;
  background-position: center;
}
.vehicle-options-browse .hybrid-options {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/020/398/original/toyota-priuses-compressor.jpg?1539806642);
  background-size: cover;
  background-position: center;
}
.vehicle-options-browse .white-background {
  background: #fff;
  min-height: 250px;
  padding: 30px 15px;
}

@media (min-width: 768px) {
  .vehicle-options-browse .clip-right {
    -webkit-clip-path: polygon(15% 0, 100% 0, 100% 100%, 15% 100%, 0% 50%);
    clip-path: polygon(15% 0, 100% 0, 100% 100%, 15% 100%, 0% 50%);
    padding-left: 7%;
  }
  .vehicle-options-browse .clip-left {
    -webkit-clip-path: polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%);
    clip-path: polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%);
    padding-right: 7%;
  }
}

.vehicle-options-browse h1 {
  font-family: 'Racing Sans One', 'Helvetica Neue', Arial, sans-serif;
}
.vehicle-options-browse .header-lg {
  -webkit-text-stroke: 1px black;
   color: white;
   text-shadow:
       3px 3px 0 #000,
     -1px -1px 0 #000,  
      1px -1px 0 #000,
      -1px 1px 0 #000,
       1px 1px 0 #000;
  font-size: 4em;
  -webkit-font-smoothing: antialiased;
}
.vehicle-options-browse a {
  display: inline-block;
}
.vehicle-options-browse img {
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
}
.vehicle-options-browse img:hover {
  transform: scale(1.08);
}
.options-row {
  min-height: 250px;
}
.options-row .text-center {
  text-align: center;
  display: block;
}
.car-wrapper, .suv-wrapper, .truck-wrapper, .hybrid-wrapper {
  text-align: center;
  margin: 15px 0;
}
@media (min-width: 768px) {
  .vehicle-options-browse .flex-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    align-self: center;
    width: 100%;
  }
  .vehicle-options-browse .flex-row .col {
    max-width: 50%;
    min-width: 33%;
  }
  .vehicle-options-browse img {
    max-height: 120px;
  }
  .vehicle-options-browse .white-background {
    display: flex;
    align-content: center;
  }
}

@media (max-width: 767px) {
  .vehicle-options-browse .white-background {
    background: rgba(255, 255, 255, .7);
  }
  .vehicle-options-browse .flex-row .col {
    width: 50% !important;
  }
  .vehicle-options-browse .flex-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    margin: auto;
  }
}
</style>
